export default __webpack_public_path__ + "static/media/imagotype-white.77acae44.svg";